import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestRestoreInventoryManager } from "./restoreInventoryManager.request";

const useRestoreInventoryManager = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchInventoryManagers = useRefetchQuery(["inventory-manager"]);

  return useMutation({
    mutationFn: requestRestoreInventoryManager,
    ...options,
    onSuccess: (...args) => {
      refetchInventoryManagers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useRestoreInventoryManager;
